<template>
<div>
    <b-modal id="matterTradeFairFormModal" ref="matterTradeFairFormModal" centered size="customize" no-close-on-backdrop :title="$t('matter.matter_trade_fair')" hide-footer>
        <b-card>
            <b-row>
                <b-col>
                    <div class="custom-search d-flex justify-content-end">
                        <b-button variant="outline-primary" size="sm" @click.prevent="addOrUpdate">
                            {{ $t('others.ok_title') }}
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTradeFair.trade_fair') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawTradeFairSelect" value-field="id" text-field="name" :options="lawTradeFairOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTradeFair.product_type') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawProductTypeSelect" value-field="id" text-field="name" :options="lawProductTypeOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTradeFair.matter_subject') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawMatterSubjectSelect" value-field="id" text-field="name" :options="lawMatterSubjectOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTradeFair.counter_party') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawCounterPartySelect" value-field="id" text-field="name" :options="lawCounterPartyOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTradeFair.visit_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="visitDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-card>
        <b-card :hidden="noteCardHidden">
            <b-row>
                <b-col class="mt-2">
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                        <b-tab :title="$t('matter.matter_note')" style="width:100%;">
                            <b-card-text>
                                <matter-note-list :lawMatterId="this.lawMatterId"></matter-note-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('lawMatterTradeFairEmployee.tab_title')" style="width:100%;">
                            <b-card-text>
                                <law-matter-trade-fair-employee-list :lawMatterTradeFairId="this.id"></law-matter-trade-fair-employee-list>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            lawTradeFairOptions: [],
            lawTradeFairSelect: 0,
            lawProductTypeOptions: [],
            lawProductTypeSelect: 0,
            lawMatterSubjectOptions: [],
            lawMatterSubjectSelect: 0,
            lawCounterPartyOptions: [],
            lawCounterPartySelect: 0,
            visitDate: null,
        }
    },
    methods: {
        async showTradeFair(id, lawMatterId) {
            this.$refs['matterTradeFairFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId

            const data = { id: this.id }
            const controller = { name: 'LawMatterTradeFair' }
            const payload = { data: data, controller: controller }

            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.lawTradeFairOptions = response.data.lawTradeFairList
                    if (this.lawTradeFairOptions != null) {
                        this.lawTradeFairOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawTradeFairSelect = response.data.lawMatterTradeFair.lawTradeFairId

                    this.lawProductTypeOptions = response.data.lawProductTypeList
                    if (this.lawProductTypeOptions != null) {
                        this.lawProductTypeOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawProductTypeSelect = response.data.lawMatterTradeFair.lawProductTypeId

                    this.lawMatterSubjectOptions = response.data.lawMatterSubjectList
                    if (this.lawMatterSubjectOptions != null) {
                        this.lawMatterSubjectOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawMatterSubjectSelect = response.data.lawMatterTradeFair.lawMatterSubjectId

                    this.lawCounterPartyOptions = response.data.lawCounterPartyList
                    if (this.lawCounterPartyOptions != null) {
                        this.lawCounterPartyOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawCounterPartySelect = response.data.lawMatterTradeFair.lawCounterPartyId

                    this.visitDate = response.data.lawMatterTradeFair.visitDate
                } else {
                    this.$bvModal.hide('matterTradeFairFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
        },
        async addOrUpdate() {
            const lawMatterTradeFairData = {
                id: this.id,
                lawMatterId: this.lawMatterId,
                lawTradeFairId: this.lawTradeFairSelect,
                lawProductTypeId: this.lawProductTypeSelect,
                lawMatterSubjectId: this.lawMatterSubjectSelect,
                lawCounterPartyId: this.lawCounterPartySelect,
                visitDate: this.visitDate,
            }
            const controller = { name: 'LawMatterTradeFair' }
            const payload = { data: lawMatterTradeFairData, controller: controller }

            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (!response.data.resultStatus) {
                this.$WarningAlert(response.data.resultMessage)
                return
            }
            if (!this.id) {
                this.id = response.data.id
                const result = await this.$SaveLawMatterMatterTypeHistory(22, this.id, this.lawMatterId, this.employeeId)
                if (!result) return
                this.getMatterTypeHistoryList()
            }
            this.$SaveAlert()
        },
    },
    computed: {
        noteCardHidden() {
            if (this.id) return false
            return true
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

@media (min-width: 992px) { .modal .modal-customize { max-width: 60% !important; width: 60% !important; } }
</style>
